export const REFINE_DROPDOWN_OPTIONS = {
  ANY: {
    text: 'Any',
    value: 'Any',
  },
  EXACTLY: {
    text: 'Exactly',
    value: 'Exactly',
  },
  BETWEEN: {
    text: 'Between',
    value: 'Between',
  },
};
